import {
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import useHasPermission from 'app/hooks/useHasPermission'
import LaneGroupCopy from '../LaneGroupCopy/LaneGroupCopy'
import LaneGroupUpdate from '../LaneGroupUpdate'

type Props = {
    id: number,
}

const LaneGroupOverview = ({
    id,
}: Props) => {
    const {
        LaneGroups: LaneGroupsRoutes,
    } = usePricingRoutes()

    const contractBasisUpdatePermission = useHasPermission(['contract_basis_update'])

    return useSkyNetRoutes({
        routes: [
            {
                path: CommonRoutes.Slash,
                element: <LaneGroupUpdate
                    id={id}
                    disabled={!contractBasisUpdatePermission}
                />,
            },
            {
                path: LaneGroupsRoutes.Copy.stringParams,
                element: <LaneGroupCopy id={id} />,
            },
        ],
    })
}

export default LaneGroupOverview
